import axios from 'axios';
import { toast } from 'react-toastify';

import instanceAxios from '../axios/instanceAxios';
import catchError from './catchError';

/**
 * The HTTP PATCH request method applies partial modifications to a resource.
 * PATCH is somewhat analogous to the "update" concept.
 *
 * @param {string} endpoint
 * @example
 * "/example/endpoint"
 * @param {object} body - { productId: 123456, siteCode: "JD" }
 * @param {string} errorMessageHeader - Message that proceeds the error message.
 * Usually to prodive context on what exactly has errored.
 * @example
 * "Get Categories"
 * @param {string?} successMessage - "Product has successfully been updated with new value"
 * @returns {Promise} { data: { Success: true, ErrorMessage: null }, status: 200 }
 */
async function patchRequest(endpoint, body, errorMessageHeader, successMessage) {
  return new Promise((resolve, reject) => {
    instanceAxios()
      .patch(endpoint, body)
      .then((response) => {
        if (response.data.Success === false) {
          reject(response.data.ErrorMessage);
        } else {
          if (successMessage?.length > 0) toast.success(successMessage);
          resolve(response);
        }
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          catchError(error, errorMessageHeader);
          reject(error);
        }
        console.error(error);
      });
  });
}

export default patchRequest;
